export function arrayToObject<T>(array: T[]): { [key: number]: T } {
	return array.reduce(
		(acc, currentObject, index) => {
			acc[index] = currentObject;
			return acc;
		},
		{} as { [key: number]: T },
	);
}
